import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../../app.constants';
import { OidcSecurityService } from '../../auth/services/oidc.security.service';
import { NonAllocatedSimResultModel } from '../../shared/models/sim-related/NonAllocatedSimResultModel';
import { NonAllocatedSimSearchParamModel } from '../../shared/models/sim-related/NonAllocatedSimSearchParamModel';
import { NonAllocatedSimModel } from '../../shared/models/sim-related/NonAllocatedSimModel';
import { ResponseModel } from '../../shared/models/ResponseModel';

@Injectable()
export class NonAllocatedSimService {

    private actionUrl: string;
    private headers: Headers;
    private uData: any;

    constructor(private _http: Http, private _configuration: Configuration, private _securityService: OidcSecurityService) {
        this.actionUrl = `${this._configuration.Server}api/NonAllocatedSim/`;
        this._securityService.getUserData().subscribe(data => this.uData = data);
    }

    private setHeaders() {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');

        let token = this._securityService.getToken();
        if (token !== '') {
            let tokenValue = 'Bearer ' + token;
            this.headers.append('Authorization', tokenValue);
        }
    }

    public GetNonAllocatedSim = (searchParams: any): Observable<NonAllocatedSimResultModel> => {
        this.setHeaders();
        let params: URLSearchParams = new URLSearchParams();
        for (let key in searchParams) {
            if (searchParams.hasOwnProperty(key)) {
                let val = searchParams[key];
                params.set(key, val);
            }
        }

        let options = new RequestOptions({ headers: this.headers, search: params });
        return this._http.get(this.actionUrl, options).map(res => res.json());
    }

    public CreateNonAllocatedSim = (newSims: NonAllocatedSimModel[]): Observable<Response> => {
        this.actionUrl = `${this._configuration.Server}api/NonAllocatedSim/`;
        this.setHeaders();

        let options = new RequestOptions({ headers: this.headers });
        return this._http.post(this.actionUrl, JSON.stringify(newSims), options);
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/sims/non-allocated-sims/non-allocated-sim.service.ts